module.exports = __webpack_public_path__ + "static/img/why-2.2c204ddb.jpg";